import { isotopeItems, testimonyItems, chartData } from "./home";
import {
	isotopeItems as isotopeItemsRo,
	testimonyItems as testimonyItemsRo,
} from "./home-ro";

export type Locale = "en" | "ro";

export function getHomeData(locale: Locale) {
	if (locale === "ro") {
		return {
			isotopeItems: isotopeItemsRo,
			testimonyItems: testimonyItemsRo,
			chartData,
		};
	}
	return {
		isotopeItems,
		testimonyItems,
		chartData,
	};
}
